import React, { useEffect, useState } from "react";
import { Box, TextField, Typography, CircularProgress, IconButton, Tooltip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AgregarCarreraModal from "./Modal/AgregarCarreraModal";
import EditarCarreraModal from "./Modal/EditarCarreraModal";
import AgregarGrupoModal from "./Modal/AgregarGrupoModal";
import EditarGrupoModal from "./Modal/EditarGrupoModal";
import ModalSemestres from "./Modal/modalSemestre";
import EditarSemestreModal from "./Modal/EditarSemestreModal";

export default function CarrerasGrupos() {
  const [carreras, setCarreras] = useState([]);
  const [grupos, setGrupos] = useState([]);
  const [carreraSeleccionada, setCarreraSeleccionada] = useState("");
  const [grupoSeleccionado, setGrupoSeleccionado] = useState("");
  const [loadingCarreras, setLoadingCarreras] = useState(false);
  const [loadingGrupos, setLoadingGrupos] = useState(false);
  const [semestre, setSemestre] = useState([]);
  const [semestresFiltrados, setSemestresFiltrados] = useState([]);
  const [semestreSeleccionado, setSemestreSeleccionado] = useState("");
  const [loadingPensums, setLoadingPensums] = useState(false);
  const [modalCarreraOpen, setModalCarreraOpen] = useState(false);
  const [modalEditarCarreraOpen, setModalEditarCarreraOpen] = useState(false);
  const [modalGrupoOpen, setModalGrupoOpen] = useState(false);
  const [modalEditarGrupoOpen, setModalEditarGrupoOpen] = useState(false);
  const [openModalSemestre, setOpenModalSemestre] = useState(false);
  const [modalEditarSemestreOpen, setModalEditarSemestreOpen] = useState(false);
  const [semestreAEditar, setSemestreAEditar] = useState(null);

  const [carreraAEditar, setCarreraAEditar] = useState(null);
  const [grupoAEditar, setGrupoAEditar] = useState(null);

  const token = sessionStorage.getItem("access_token");

  const handleOpenSemestre = (carrera) => {
    setCarreraSeleccionada(carrera);
    setOpenModalSemestre(true);
  };
  const handleCloseSemestre = () => {
    setOpenModalSemestre(false);
    setCarreraSeleccionada(null);
  };
  const handleSemestreChange = (event) => {
    setSemestreSeleccionado(event.target.value);
    cargarGruposSemestre(event.target.value);
  };

  // 🔹 Cargar carreras
  const cargarCarreras = () => {
    setLoadingCarreras(true);
    fetch(`${process.env.REACT_APP_API_URL}/carreras`, {
      headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
    })
      .then((res) => res.json())
      .then((data) => {
        const lista = Array.isArray(data.data) ? data.data : data;
        setCarreras(lista || []);
        setLoadingCarreras(false);
      })
      .catch((err) => {
        console.error(err);
        setCarreras([]);
        setLoadingCarreras(false);
      });
  };
  const cargarSemestres = (tipo, programa_id) => {

    fetch(`${process.env.REACT_APP_API_URL}/semestre/${tipo}/${programa_id}`,{
      headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
    })
    .then((res) => res.json())
    .then((data)=> {
      const lista = Array.isArray(data.data) ? data.data : data;
      setSemestresFiltrados(lista || []);
    })
    .catch((err)=>{
      console.error(err);
      setSemestresFiltrados([]);
    });
  }

  useEffect(() => {
    cargarCarreras();
  }, [token]);
  const cargarGruposSemestre = (semestreId) => {
    setLoadingGrupos(true);
    // Cambiamos el endpoint para pedir los grupos del Pensum en Laravel
    fetch(`${process.env.REACT_APP_API_URL}/grupos/${semestreId}/semestres`, {
      headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
    })
      .then((res) => res.json())
      .then((data) => {
        const lista = Array.isArray(data.data) ? data.data : data;
        setGrupos(lista || []);
        setLoadingGrupos(false);
      })
      .catch((err) => {
        console.error(err);
        setGrupos([]);
        setLoadingGrupos(false);
      });
  };

  const handleEliminarGrupo = async () => {
    if ( !grupoSeleccionado) {
      alert("Primero selecciona un grupo para eliminar.");
      return;
    }

    // Confirmación antes de eliminar
    const confirmDelete = window.confirm("¿Estás seguro de eliminar este grupo?");
    if (!confirmDelete) return;

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/modulos/grupo/${grupoSeleccionado}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );

      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Error al eliminar grupo");

      alert("Grupo eliminado correctamente");

      // 🔹 Refrescar la lista de grupos y limpiar selección
      cargarGruposSemestre(semestreSeleccionado);
      setGrupoSeleccionado("");
    } catch (error) {
      console.error("Error al eliminar grupo:", error);
      alert(error.message);
    }
  };

  const handleEliminarCarrera = async () => {
    if ( !carreraSeleccionada) {
      alert("Primero selecciona una carrera para eliminar.");
      return;
    }

    // Confirmación antes de eliminar
    const confirmDelete = window.confirm("¿Estás seguro de eliminar esta carrera?");
    if (!confirmDelete) return;

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/modulos/carrera/${carreraSeleccionada}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );

      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Error al eliminar grupo");

      alert("Grupo eliminado correctamente");

      // 🔹 Refrescar la lista de grupos y limpiar selección
      setGrupoSeleccionado("");
    } catch (error) {
      console.error("Error al eliminar grupo:", error);
      alert(error.message);
    }
  };
  const handleEliminarSemestre = async () => {
    if ( !semestreSeleccionado) {
      alert("Primero selecciona un semestre para eliminarlo.");
      return;
    }

    // Confirmación antes de eliminar
    const confirmDelete = window.confirm("¿Estás seguro de eliminar este semestre?");
    if (!confirmDelete) return;

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/semestres/eliminar/${semestreSeleccionado}`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );

      const data = await res.json();
      if (!res.ok) throw new Error(data.message || "Error al eliminar grupo");

      alert("Semestre eliminado correctamente");
      window.location.reload(); 
      // 🔹 Refrescar la lista de grupos y limpiar selección
      setSemestreSeleccionado("");
    } catch (error) {
      console.error("Error al eliminar grupo:", error);
      alert(error.message);
    }
  };

  // 🔹 Cambio de carrera
  const handleCarreraChange = (event) => {
    const carreraId = event.target.value;
    setCarreraSeleccionada(carreraId);
    cargarSemestres("carrera",carreraId);
    setGrupoSeleccionado("");
    
    setGrupos([]);

  };
  
  // 🔹 Cambio de grupo
  const handleGrupoChange = (event) => {
    setGrupoSeleccionado(event.target.value);
  };

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h5" mb={3}>
        Seleccionar Carrera y Grupo
      </Typography>

    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap", // 🔥 CLAVE
        gap: 2,
        alignItems: "center",
      }}
    >
      
      {/* 🏫 1. SELECT CARRERA */}
      {loadingCarreras ? (
        <CircularProgress size={24} />
      ) : (
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: { xs: "column", md: "row" }, // 🔥 magia
            gap: 1,
            alignItems: { xs: "stretch", md: "center" },
          }}
        >
          <TextField
            select
            fullWidth
            label="Carrera"
            value={carreraSeleccionada}
            onChange={handleCarreraChange}
            InputLabelProps={{ shrink: true }}
            SelectProps={{ native: true }}
          >
            <option value=""></option>
            {carreras.map((carrera) => (
              <option key={carrera.id} value={carrera.id}>
                {carrera.nombre}
              </option>
            ))}
          </TextField>
          <Box
            sx={{
              display: "flex",
              gap: 0.5,
              flexWrap: { xs: "wrap", md: "nowrap" }, // 🔥 clave
              flexDirection: { xs: "row", md: "row" }, // siempre fila
              justifyContent: { xs: "flex-start", md: "center" },
            }}
          >
            <Tooltip title="Agregar carrera">
              <IconButton color="primary" onClick={() => setModalCarreraOpen(true)}>
                <AddIcon />
              </IconButton>
            </Tooltip>

            <Tooltip title="Editar carrera">
              <span>
                <IconButton
                  color="secondary"
                  disabled={!carreraSeleccionada}
                  onClick={() => {
                    setCarreraAEditar(carreraSeleccionada);
                    setModalEditarCarreraOpen(true);
                  }}
                >
                  <EditIcon />
                </IconButton>
              </span>
            </Tooltip>
            <Tooltip title="Eliminar capacitación">
              <span>
                <IconButton color="error" disabled={!carreraSeleccionada} onClick={handleEliminarCarrera}>
                  <DeleteIcon />
                </IconButton>
              </span>
            </Tooltip>
          </Box>
          
          <TextField
            select
            fullWidth
            label="Semestres/Años"
            value={semestreSeleccionado}
            onChange={handleSemestreChange}
            disabled={!carreraSeleccionada}
            InputLabelProps={{ shrink: true }}
            SelectProps={{ native: true }}
          >
            <option value=""></option>
            {semestresFiltrados.map((s) => (
              <option key={s.id} value={s.id}>
                {s.nombre} {s.numero}
              </option>
            ))}
          </TextField>
          <Box
            sx={{
              display: "flex",
              gap: 0.5,
              flexWrap: { xs: "wrap", md: "nowrap" }, // 🔥 clave
              flexDirection: { xs: "row", md: "row" }, // siempre fila
              justifyContent: { xs: "flex-start", md: "center" },
            }}
          >
            <Tooltip title="Agregar carrera">
              <IconButton color="primary" onClick={() => handleOpenSemestre(carreraSeleccionada)}>
                <AddIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Editar semestre">
              <span>
                <IconButton
                  color="secondary"
                  disabled={!semestreSeleccionado}
                  onClick={() => {
                    setSemestreAEditar(semestreSeleccionado);
                    setModalEditarSemestreOpen(true);
                  }}
                >
                  <EditIcon />
                </IconButton>
              </span>
            </Tooltip>
            <Tooltip title="Eliminar semestre">
              <span>
                <IconButton color="error" disabled={!semestreSeleccionado} onClick={handleEliminarSemestre}>
                  <DeleteIcon />
                </IconButton>
              </span>
            </Tooltip>
          </Box>
        </Box>
      )}
    </Box> {/* 🏁 Fin de la Fila 1 */}

      {/* Selección de grupo */}
      {loadingGrupos ? (
        <CircularProgress size={24} />
      ) : (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1,mt: 4 }}>
          <TextField
            select
            fullWidth
            label="Grupo"
            value={grupoSeleccionado}
            SelectProps={{ native: true }}
            InputLabelProps={{ shrink: true }}
            onChange={handleGrupoChange}
          >
            <option value=""></option>
            {grupos.length > 0 ? (
              grupos.map((grupo) => (
                <option key={grupo.id} value={grupo.id}>
                  {grupo.nombre} ({grupo.turno})
                </option>
              ))
            ) : (
              <option value="" disabled>
                No hay grupos
              </option>
            )}
          </TextField>

          <Tooltip title="Agregar grupo">
            <IconButton
              color="primary"
              onClick={() => {
                if (!carreraSeleccionada) return alert("Selecciona una carrera primero");
                setModalGrupoOpen(true);
              }}
            >
              <AddIcon />
            </IconButton>
          </Tooltip>

          <Tooltip title="Editar grupo">
            <span>
              <IconButton
                color="secondary"
                disabled={!grupoSeleccionado}
                onClick={() => {
                  setGrupoAEditar(grupoSeleccionado);
                  setModalEditarGrupoOpen(true);
                }}
              >
                <EditIcon />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title="Eliminar grupo">
            <span>
              <IconButton
                color="error"
                disabled={!grupoSeleccionado}
                onClick={handleEliminarGrupo}
              >
                <DeleteIcon />
              </IconButton>
            </span>
          </Tooltip>
        </Box>
      )}

      {/* Modales */}
      <AgregarCarreraModal
        open={modalCarreraOpen}
        onClose={() => setModalCarreraOpen(false)}
        onCarreraAgregada={cargarCarreras}
        
      />
      <EditarCarreraModal
        open={modalEditarCarreraOpen}
        onClose={() => setModalEditarCarreraOpen(false)}
        carreraId={carreraAEditar}
        onCarreraActualizada={cargarCarreras}
      />
      <AgregarGrupoModal
        open={modalGrupoOpen}
        onClose={() => setModalGrupoOpen(false)}
        onGrupoAgregado={() => cargarGruposSemestre(semestreSeleccionado)}
        semestres={semestresFiltrados}
      />
      <EditarGrupoModal
        open={modalEditarGrupoOpen}
        onClose={() => setModalEditarGrupoOpen(false)}
        grupoId={grupoSeleccionado}
        onGrupoActualizado={() => cargarGruposSemestre(semestreSeleccionado)}
        tipo = {"carrera"}
        carrera_id = {carreraSeleccionada}
      />
      <ModalSemestres
        open={openModalSemestre}
        onClose={() => setOpenModalSemestre(false)}
        carrera_id={carreraSeleccionada}
        onSemestreCreado={() => {
          cargarSemestres("carrera", carreraSeleccionada);
          setSemestreSeleccionado(""); // 🔥 limpia selección
          setGrupos([]); // 🔥 opcional limpiar grupos
        }}
      />
      <EditarSemestreModal
        open={modalEditarSemestreOpen}
        onClose={() => setModalEditarSemestreOpen(false)}
        semestreId={semestreAEditar}
        onActualizado={() => {
          cargarSemestres("carrera", carreraSeleccionada);
        }}
      />
    </Box>
  );
}
